import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Kan jag överlåta mitt serveringstillstånd till en ny ägare?";
const SHORT_ANSWER = "Nej. Serveringstillståndet är personligt knutet till tillståndshavaren och kan inte överlåtas. Den nya ägaren måste söka eget tillstånd.";

export const Route = createFileRoute("/fraga/kan-jag-overlata-mitt-tillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Kan jag överlåta mitt serveringstillstånd till …" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Vid ägarbyte ska du genast anmäla det till kommunen, och köparen måste söka eget tillstånd. Många kommuner erbjuder snabb 'övergångsprövning' så att verksamheten kan fortsätta utan avbrott, men det är ett nytt beslut."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Serveringstillstånd – guide" }}
      related={[{"to": "/fraga/hur-anmaler-jag-andringar", "label": "Hur anmäler jag ändringar i min verksamhet?"}, {"to": "/fraga/nar-behover-jag-anmala-ny-agare", "label": "När måste jag anmäla ny ägare eller styrelseledamot?"}, {"to": "/fraga/vad-ar-provsmakningstillstand", "label": "Vad är ett provsmakningstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Kan jag överlåta mitt serveringstillstånd till en ny ägare?" },
      { name: "description", content: "Nej. Serveringstillståndet är personligt knutet till tillståndshavaren och kan inte överlåtas. Den nya ägaren måste söka eget tillstånd." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/kan-jag-overlata-mitt-tillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/kan-jag-overlata-mitt-tillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/kan-jag-overlata-mitt-tillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Kan jag överlåta mitt serveringstillstånd till …", url: "https://alkoholprovet.se/fraga/kan-jag-overlata-mitt-tillstand" },
      ]),
    ],
  }),
});
